import { computed, inject, provide, unref, useId } from 'vue'

export const FORM_FIELD_KEY = Symbol('eqsysFormField')

/**
 * Provide form-field chrome context (id, describedby, invalid, density)
 * for slotted Base* controls.
 */
export function provideFormField(options) {
  const autoId = useId()
  const controlId = computed(() => unref(options.id) || autoId)
  const describedby = computed(() => {
    const parts = [unref(options.hintId), unref(options.errorId)].filter(Boolean)
    return parts.join(' ') || undefined
  })
  const ctx = computed(() => ({
    id: controlId.value,
    describedby: describedby.value,
    invalid: !!unref(options.invalid),
    density: unref(options.density) || 'default',
    required: !!unref(options.required),
  }))
  provide(FORM_FIELD_KEY, ctx)
  return { controlId, describedby, ctx }
}

/**
 * Consume parent BaseFormField context when present.
 */
export function useFormFieldContext() {
  const parent = inject(FORM_FIELD_KEY, null)
  return {
    parent,
    resolveId(propId) {
      return propId || parent?.value?.id
    },
    resolveDescribedby(propDescribedby) {
      return propDescribedby || parent?.value?.describedby
    },
    resolveInvalid(propInvalid) {
      if (propInvalid != null) return !!propInvalid
      return !!parent?.value?.invalid
    },
    resolveDensity(propDensity) {
      return propDensity || parent?.value?.density || 'default'
    },
  }
}
